<div class="otp-wrapper" style="max-width: calc(100% - 40px); margin: auto;">
  <!-- Step 1: enter phone -->
  @if (stage === 'enterPhone') {
    <div class="w-full h-screen flex flex-col justify-center items-center">
      <h2 class="h-1/3 flex items-center">{{ 'EnterPhone' | localizeText : 'Enter Phone' }}</h2>
      <div class="h-2/3 w-full">
        <app-intl-phone-num (phoneNumberChanged)="phoneNumber = $event.e164Number" fontSize="22px"></app-intl-phone-num>
        <div class="flex justify-end">
          <div class="rounded-full cursor-pointer mt-5 p-4 bg-blue-850 text-white" (click)="sendOtp()" style="padding-left: 18px">
            <app-icon icon="chevron-right"></app-icon>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Step 2: enter code -->
  @if (stage === 'enterCode') {
    <div class="w-full h-screen flex flex-col justify-center items-center">
      <!-- Header takes 1/3 height -->
      <h2 class="h-1/3 flex items-center">
        {{ 'EnterVerificationCode' | localizeText : 'Enter verification code' }}
      </h2>
      <!-- Body takes 2/3 height -->
      <div class="h-2/3 flex flex-col justify-start w-full">
        <!-- You could swap this for six separate inputs or a custom OTP component -->
        <input
          type="text"
          style="font-size: 22px"
          maxlength="6"
          [(ngModel)]="verificationCode"
          placeholder="••••••"
          class="w-full text-center text-2xl p-3 tracking-widest border-b-2 input-default py-2"
          />
        <!-- Arrow button aligned bottom-right -->
        <div class="flex justify-end mt-auto">
          <div
            class="rounded-full p-4 cursor-pointer bg-blue-850 text-white cursor-pointer"
            (click)="verifyOtp()"
            >
            <app-icon icon="chevron-right"></app-icon>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Error message -->
  @if (errorMessage) {
    <p class="error">{{ errorMessage }}</p>
  }
</div>
